import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// tslint:disable-next-line:import-spacing
import { RetourComponent } from  './retour.component';
import {TableModule} from 'primeng/table';
import {PanelModule} from 'primeng/panel';
import {ButtonModule} from 'primeng/button';


@NgModule({
  declarations: [RetourComponent],
  imports: [
    CommonModule,
    TableModule,
    PanelModule,
    ButtonModule
  ]
})
export class RetourModule { }
